import React, { useState } from 'react';
import './Contact.css';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaMapMarkedAlt, FaClock } from 'react-icons/fa';
import { useGlobalContext } from '../../Components/Base_url/GobelContaxt';
const Contacts = () => {
    const { contactData } = useGlobalContext();

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
    });

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [id]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle form submission here
        console.log('Form submitted:', formData);
        alert('Message sent successfully!');
        setFormData({
            name: '',
            email: '',
            phone: '',
            subject: '',
            message: ''
        });
    };

    return (
        <div className="Contacts-page">
            {/* Hero Section */}
            <section className="Contacts-hero">
                <div className="Contacts-container">
                    <h1 className="Contacts-fade-in">Contact Us</h1>
                    <p className="Contacts-fade-in">We'd love to hear from you. Send us a message and we'll respond as soon as possible.</p>
                </div>
            </section>

            {/* Main Content */}
            <section className="Contacts-main">
                <div className="Contacts-container">
                    <div className="Contacts-contact-container">
                        {/* Contact Form */}
                        <div className="Contacts-contact-form Contacts-slide-in-left">
                            <h2>Send a Message</h2>
                            <form onSubmit={handleSubmit}>
                                <div className="Contacts-form-group">
                                    <label htmlFor="name">Full Name</label>
                                    <input
                                        type="text"
                                        id="name"
                                        className="Contacts-form-control"
                                        placeholder="Your Name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="Contacts-form-group">
                                    <label htmlFor="email">Email Address</label>
                                    <input
                                        type="email"
                                        id="email"
                                        className="Contacts-form-control"
                                        placeholder="Your Email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="Contacts-form-group">
                                    <label htmlFor="phone">Phone Number</label>
                                    <input
                                        type="tel"
                                        id="phone"
                                        className="Contacts-form-control"
                                        placeholder="Your Phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="Contacts-form-group">
                                    <label htmlFor="subject">Subject</label>
                                    <input
                                        type="text"
                                        id="subject"
                                        className="Contacts-form-control"
                                        placeholder="Subject"
                                        value={formData.subject}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="Contacts-form-group">
                                    <label htmlFor="message">Message</label>
                                    <textarea
                                        id="message"
                                        className="Contacts-form-control"
                                        placeholder="Your Message"
                                        rows="5"
                                        value={formData.message}
                                        onChange={handleChange}
                                        required
                                    ></textarea>
                                </div>
                                <button type="submit" className="Contacts-btn Contacts-btn-primary">Send Message</button>
                            </form>
                        </div>

                        {/* Contact Information */}
                        <div className="Contacts-contact-info Contacts-slide-in-right">
                            <h2>Contact Information</h2>
                            <div className="Contacts-info-item">
                                <div className="Contacts-info-icon">
                                    <FaMapMarkerAlt />
                                </div>
                                <div className="Contacts-info-details">
                                    <h4>{contactData?.ContactUs_Address1_head}</h4>
                                    <p>{contactData?.ContactUs_Address1 ? contactData?.ContactUs_Address1 : contactData?.ContactUs_Address2}</p>
                                </div>
                            </div>
                            <div className="Contacts-info-item">
                                <div className="Contacts-info-icon">
                                    <FaPhoneAlt />
                                </div>
                                <div className="Contacts-info-details">
                                    <h4>Phone Number</h4>
                                    <p>{contactData?.ContactUs_Mobile_Number}</p>
                                    {/* <p>{contactData?.ContactUs_Mobile_Number}</p> */}
                                </div>
                            </div>
                            <div className="Contacts-info-item">
                                <div className="Contacts-info-icon">
                                    <FaEnvelope />
                                </div>
                                <div className="Contacts-info-details">
                                    <h4>{contactData?.ContactUs_Emailid_header} </h4>
                                    <p>{contactData?.ContactUs_EMAIL_ID}</p>
                                    {/* <p>support@companyname.com</p> */}
                                </div>
                            </div>
                            <div className="Contacts-info-item">
                                <div className="Contacts-info-icon">
                                    <FaEnvelope />
                                </div>
                                <div className="Contacts-info-details">
                                    <h4>Website</h4>
                                    <p>https://callforcabs.com</p>
                                    {/* <p>support@companyname.com</p> */}
                                </div>
                            </div>



                            {/* Social Links */}
                            <div className="Contacts-social-links">
                                <h3>Follow Us</h3>
                                <div className="Contacts-social-icons">
                                    <a href="#" className="Contacts-social-icon"><FaFacebookF /></a>
                                    <a href="#" className="Contacts-social-icon"><FaTwitter /></a>
                                    <a href="#" className="Contacts-social-icon"><FaInstagram /></a>
                                    <a href="#" className="Contacts-social-icon"><FaLinkedinIn /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Map Section */}
            <section className="Contacts-map-section">
                <div className="Contacts-container">
                    <div className="Contacts-map-container Contacts-fade-in">
                        <div className="Contacts-map-placeholder">
                            <FaMapMarkedAlt />
                            <p>Google Maps will be displayed here</p>
                            <div className="col-xl-6 wow fadeInRight" data-wow-delay="0.2s">
                                <div className="rounded h-100">

                                    {/* <iframe className="rounded h-100 w-100" style={{height: 400}} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d387191.33750346623!2d-73.97968099999999!3d40.6974881!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew%20York%2C%20NY%2C%20USA!5e0!3m2!1sen!2sbd!4v1694259649153!5m2!1sen!2sbd" loading="lazy" referrerPolicy="no-referrer-when-downgrade" /> */}

                                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d227748.43602508202!2d75.62574553085896!3d26.885421390141282!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396c4adf4c57e281%3A0xce1c63a0cf22e09!2sJaipur%2C%20Rajasthan!5e0!3m2!1sen!2sin!4v1755772091300!5m2!1sen!2sin" width={600} height={800} style={{ border: 0 }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Contacts;